import recruitment from "../../services/jobOffer"

export default {
    namespaced: true,
    state: {
        inscriptionData: {
          transportTypes: null
        }
    },
    mutations: {
      SET_TRANSPORT_TYPE: (state, types) => {
        state.inscriptionData.transportTypes = types;
      }
    },
    actions: {
      getTransportTypes(store) {
        return new Promise((resolve, reject) => {
          recruitment.getTransportTypes().then(res => {
            if (res.success) {
              store.commit('SET_TRANSPORT_TYPE', res.data);
              resolve(res);
            } else {
              reject();
            }
          }).catch(err => {
            reject(err);
          })
        });
      }
    },
    getters: {
        transportTypes(state) {
            return state.inscriptionData.transportTypes;
        }
    }
}
